const BASE = "https://customer-assets-agu9un31.emergentagent.net/job_repair-assistant-19/artifacts";

const JOBS = [
  {
    title: "Garage door replacement",
    aspect: "aspect-[3/4]",
    photos: ["b9cc3c1f81b86efb_822_Before.webp", "f0f18fee7b83abe8_822_After.webp"],
  },
  {
    title: "Spring repair",
    aspect: "aspect-[3/4]",
    photos: ["/spring-before.webp", "/spring-after.webp"],
  },
  {
    title: "Custom door install",
    aspect: "aspect-[4/3]",
    photos: ["2b2752e5826fdeb5_IMG_Custom%20door_pre.webp"],
  },
];

const labelFor = (file) => (/before/i.test(file) ? "Before" : /after/i.test(file) ? "After" : null);

function Photo({ file, aspect, alt }) {
  const label = labelFor(file);
  return (
    <div className={`relative overflow-hidden border-2 border-black bg-zinc-200 ${aspect} group`}>
      <img
        src={file.startsWith("/") ? `${process.env.PUBLIC_URL}${file}` : `${BASE}/${file}`}
        alt={label ? `${alt} – ${label.toLowerCase()}` : alt}
        loading="lazy"
        className="absolute inset-0 w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
      />
      {label && (
        <span
          data-testid={`gallery-label-${label.toLowerCase()}`}
          className={`absolute top-3 ${label === "Before" ? "left-3 bg-black" : "right-3 bg-[#B22234]"} text-white border-2 border-white px-3 py-1.5 font-mono text-xs uppercase tracking-[0.25em] font-semibold shadow-[3px_3px_0_#000]`}
        >
          {label}
        </span>
      )}
    </div>
  );
}

export default function WorkGallery() {
  return (
    <section id="our-work" data-testid="our-work-gallery" className="max-w-7xl mx-auto px-6 md:px-12 pb-20 md:pb-28">
      <div className="mb-10">
        <div className="font-mono text-[10px] tracking-[0.2em] uppercase text-zinc-600">/ Our work</div>
        <h2 className="font-display text-4xl md:text-5xl font-semibold uppercase tracking-tight mt-2">
          Real jobs. <span className="text-[#B22234]">Real results</span>.
        </h2>
      </div>
      <div className="space-y-10">
        {JOBS.map((job, i) => (
          <figure key={job.title} data-testid={`gallery-job-${i}`}>
            <div className={`grid gap-4 ${job.photos.length > 1 ? "grid-cols-1 sm:grid-cols-2" : "grid-cols-1 max-w-3xl"}`}>
              {job.photos.map((f) => (
                <Photo key={f} file={f} aspect={job.aspect} alt={job.title} />
              ))}
            </div>
            <figcaption className="mt-3 font-mono text-[11px] uppercase tracking-[0.25em] text-zinc-700">
              0{i + 1} · {job.title}
            </figcaption>
          </figure>
        ))}
      </div>
    </section>
  );
}
